<template>
	<div class="logo-text">
		<template v-if="lang === 'ru'">
            <b style='    font-size: 18px;line-height: 1.36;'>ИНСТИТУТ МИРОВОЙ</b> <br/>
            <span style="font-size:13.8px">ЭКОНОМИКИ И ПОЛИТИКИ</span>
		</template>
		<template v-if="lang === 'kz'">
            <b style='font-size:15px;'>{{"ӘЛЕМДІК ЭКОНОМИКА".kzToLatin()}}</b> <br/>
            <span style="font-size:12.3px">{{"ЖӘНЕ САЯСАТ ИНСТИТУТЫ".kzToLatin()}}</span>
		</template>
		<template v-if="lang === 'en'">
            <b style='font-size:15px;'>INSTITUTE OF WORLD</b> <br/>
            <span style="font-size:11.8px">ECONOMICS AND POLITICS</span>
		</template>
	</div>
</template>

<script>
export default {

  name: 'logo-text',

  computed:{
    lang(){return this.$store.state.lang;},
    tr(){return this.$store.getters.translates;}
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.logo-text b{
  font-size:15px;
  text-transform: uppercase;
}

.logo-text span{
  font-size:11.3px;
  text-transform: uppercase;
  
}

</style>